// JavaScript
import 'src/scripts/main'

// Styles
import 'src/assets/styles/main.scss'

// Favicon
// import 'src/assets/images/favicon.ico'

// Web App Manifest
import 'src/site.webmanifest'
